import React from 'react';
import { smsSegmentCount, withSmsOptOutLine } from '../../lib/smsText';
import LockIcon from './LockIcon';
import r from './StalledReminders.module.scss';

interface SmsComposerProps {
  body: string;
  onChange: (body: string) => void;
  /** Shown locked below the field, outside it: the server appends it to whatever body is sent. */
  optOutLine: string;
}

/** A one-off text's editable body, with the opt-out line it always ends with and what it adds up to. */
export default function SmsComposer({ body, onChange, optOutLine }: SmsComposerProps) {
  const sent = withSmsOptOutLine(body, optOutLine);
  const texts = smsSegmentCount(sent);
  return (
    <>
      <div className={r.fieldLabel}>
        Message <span className={r.fieldLabelAux}>The opt-out line can't be removed</span>
      </div>
      <div className={r.smsEdit}>
        <textarea
          className={r.smsEditInput}
          value={body}
          onChange={(e) => onChange(e.target.value)}
          rows={4}
          aria-label="Message"
        />
        <div className={r.optOutLine}>
          <LockIcon className={r.optOutLock} />
          <span>{optOutLine}</span>
        </div>
      </div>
      <div className={r.smsMeta}>
        <span className={r.smsNote}>Every text ends with an opt-out line naming your rescue.</span>
        <span className={r.charCount}>
          {sent.length} characters · {texts} {texts === 1 ? 'text' : 'texts'}
        </span>
      </div>
    </>
  );
}
